// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"106a818f","879":"d17980b1"}[chunkId] + ".chunk.js";
};